import { render, staticRenderFns } from "./QuestionnaireStartButtons.vue?vue&type=template&id=9d53d31e&"
import script from "./QuestionnaireStartButtons.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireStartButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports